import { Action, ActionReducer } from '@ngrx/store';

import { ActionConstants } from '../constants/action.constants';

export interface AnyObjectState {
	object: any;
}

export const initialState: AnyObjectState = {
	object: null
};

export function createReducerWithName(name: string): ActionReducer<any, Action> {
	if (!name) {
		throw new Error('Error in createReducerWithName: name cannot be empty!');
	}

	name = name.toUpperCase();

	return function create(state = initialState, action: any): AnyObjectState {
		switch (action.type) {
			case ActionConstants.LOAD_ONE + name: {
				return { ...state, object: action.payload };
			}

			default: {
				return state;
			}
		}
	};
}

export const getObject = (state: AnyObjectState) => state.object;
